import { get } from '@core/api/baseApi';
import ReportsSource, { reportsBasePath } from '../types/ReportsSource';
import { StudyReportsResponse } from '../types/StudyReportItem';

const getStudyReports = (source: ReportsSource): Promise<StudyReportsResponse> =>
  get<StudyReportsResponse>(
    source.kind === 'study' ? `${reportsBasePath(source)}/published` : reportsBasePath(source),
  );

export default getStudyReports;
